// Frontend wrapper for the dashboard's headless SEAL value endpoint.
//
// Hits the dev-server proxy at /_seal/value/:reportId (defined in
// src/setupProxy.js), which performs SWILogin + SWExecuteReport against
// SEAL and aggregates the resulting table to a scalar.
//
// Returns the raw response object — at minimum { value }, plus a `debug`
// section with the tables the parser found (useful for diagnosing why a
// widget shows no value).

const buildQueryString = (params) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.append(key, String(value));
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
};

export const fetchReportValue = async ({
  reportId,
  path,
  column,
  aggregate,
  modelName,
  from,
  to,
}) => {
  const qs = buildQueryString({ path, column, aggregate, modelName, from, to });
  const res = await fetch(`/_seal/value/${reportId}${qs}`, {
    credentials: 'include',
  });
  if (!res.ok) {
    let detail = '';
    try {
      detail = JSON.stringify(await res.json());
    } catch (_) {
      // ignore
    }
    throw new Error(`Value fetch failed: ${res.status} ${detail}`);
  }
  return res.json();
};
